import { inject, Injectable, OnDestroy } from '@angular/core';
import { MicrosoftLicensesConfigsResource } from '../../helpdesk/shared/resources/microsoft-licenses-configs.resource';
import { Microsoft365LicensesFieldConfig } from '../models/generated/ziroModels';
import { filter, Observable, ReplaySubject, Subscription } from 'rxjs';
import { MicrosoftTenantsStateContext } from './microsoft-tenants-state.context';

@Injectable()
export class MicrosoftLicensesContext implements OnDestroy {
  private microsoftLicensesConfigsResource = inject(MicrosoftLicensesConfigsResource);
  private _tenantsStateContext = inject(MicrosoftTenantsStateContext);

  // public so stages can access
  _stateSource = new ReplaySubject<Microsoft365LicensesFieldConfig>(1);
  state$ = this._stateSource.asObservable();

  private _tenantId: string;
  private _sub = new Subscription();

  constructor() {
    const cachedTenantSub = this._tenantsStateContext.cachedTenantState$
      .pipe(filter((cachedTenant) => !!cachedTenant?.tenantId))
      .subscribe((cachedTenant) => {
        this._tenantId = cachedTenant.tenantId.toString();
        this.refresh().subscribe();
      });

    this._sub.add(cachedTenantSub);
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  refresh(): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.microsoftLicensesConfigsResource
        .getLicensesConfig(this._tenantId)
        .subscribe((licenses: Microsoft365LicensesFieldConfig) => {
          this._stateSource.next(licenses);
          subscriber.next(null);
          subscriber.complete();
        });
    });
  }
}
